<template>
  <div class="loading-menu-item">
    <div class="inner">
      <div class="skelton" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@keyframes loading {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}

.loading-menu-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 40px;
  overflow: hidden;

  .inner {
    position: relative;
    width: 100%;
    height: 14px;
    overflow: hidden;
  }

  .skelton {
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(var(--v-theme-ui-white), 0.5),
      transparent
    );
    animation: loading 1s linear infinite;
  }
}
</style>
